/* Bamboo PDP V2 — buy box logic.
 *
 * Arm-aware (window.OSC_ARM, sticky, set in <head>):
 *   A (control) — tag-tier bundle prices; totals computed with the SAME greedy
 *     chunking as the checkout Function (bundle-core.js), so the displayed
 *     bundle total always matches checkout. The mask (@3) rides via the
 *     sidecart's auto-add program; the pillowcase set (@6) is user-picked here
 *     and stamped at ATC with the same properties the sidecart would use — the
 *     sidecart then sees it as present and skips its color-matched default.
 *   B (v3 percent ladder) — 1/2/4 rungs priced from the bundle:v3b: tag
 *     (window.OSCV3B, shared math with the checkout Function):
 *     total(2) = unit + inc2, total(4) = unit + inc2 + 2·incN. All slots are
 *     PAID lines; the Function applies the group discount at checkout. Gifts:
 *     mask @3+ (the 4-pack earns it, stamped _osc_gift_min 3); the 6-set
 *     pillowcase gift is unreachable in arm B. The old BXGY path is retired.
 */
(function () {
  "use strict";
  var cfgEl = document.querySelector("[data-bb2-config]");
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var ARM = window.OSC_ARM === "B" ? "B" : "A";
  // v3 shared percent-ladder helper (loaded blocking in <head>). Arm B only.
  var V3 = ARM === "B" && window.OSCV3B ? window.OSCV3B : null;
  if (ARM === "B" && !V3) ARM = "A"; // helper missing: fail safe to control math
  // Big tier: arm A sells a 6-set tier bundle; arm B's big rung is 4 sets.
  // Gift thresholds stay >= 3 (mask) / >= 6 (pillowcases — unreachable in B).
  var BIG_TIER = ARM === "B" ? 4 : 6;
  var VARIANTS = CFG.variants || [];

  // Facebook/Instagram sessions open on a lifestyle hero instead of the variant
  // shot. Sticky via sessionStorage; released on any size/color/thumb pick.
  var FB_HERO = false;
  try {
    var fbQs = new URLSearchParams(location.search);
    var fromFb =
      /facebook\.com|fb\.com|instagram\.com/i.test(document.referrer) ||
      fbQs.has("fbclid") ||
      /^(facebook|fb|ig|instagram|meta)$/i.test(fbQs.get("utm_source") || "");
    if (fromFb) sessionStorage.setItem("osc_fb_sess", "1");
    FB_HERO = !!CFG.fbImg && (fromFb || sessionStorage.getItem("osc_fb_sess") === "1");
  } catch (e) {}
  var SIZES = CFG.sizes || [];
  var COLORS = CFG.colors || [];

  function money(cents) {
    var n = (cents / 100).toFixed(2);
    return "$" + n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  // <option> can't render <s>, so gift prices are struck with U+0336 overlays.
  function strike(txt) { return String(txt).replace(/[\s\S]/g, "$&\u0336"); }
  function handleize(s) {
    return String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }

  function findVariant(size, color) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].size === size && VARIANTS[i].color === color) return VARIANTS[i];
    }
    return null;
  }
  function firstAvailableColor(size, preferred) {
    var v = findVariant(size, preferred);
    if (v && v.available) return preferred;
    for (var i = 0; i < COLORS.length; i++) {
      var w = findVariant(size, COLORS[i]);
      if (w && w.available) return COLORS[i];
    }
    return preferred;
  }
  function sizeMinPrice(size) {
    var p = 0;
    VARIANTS.forEach(function (v) { if (v.size === size && (!p || v.price < p)) p = v.price; });
    return p;
  }

  /* ---------- tag tiers (arm A) — port of bcl-resolve-bundle-tiers + bundle-core ---------- */
  // "3-249|6-429" -> [{units:3, cents:24900}, ...]
  function parseTiers(str) {
    if (!str) return [];
    return String(str).split("|").map(function (seg) {
      seg = seg.trim();
      var dash = seg.lastIndexOf("-");
      if (dash <= 0) return null;
      var units = parseInt(seg.slice(0, dash), 10);
      var price = parseFloat(seg.slice(dash + 1).replace(/,/g, ""));
      if (isNaN(units) || isNaN(price)) return null;
      return { units: units, cents: Math.round(price * 100) };
    }).filter(Boolean);
  }
  // Scoped bundle tags: [{skuPrefix, tiersStr}] + optional global tier string.
  var TIER_SCOPES = [];
  var TIER_GLOBAL = "";
  (CFG.tags || []).forEach(function (tag) {
    var tl = String(tag).toLowerCase().trim();
    var pfxs = ["bundle:default:", "bundle:global:", "bundle:blackfriday:"];
    for (var i = 0; i < pfxs.length; i++) {
      var at = tl.indexOf(pfxs[i]);
      if (at !== 0) continue;
      var payload = String(tag).trim().slice(pfxs[i].length).trim();
      if (!payload) return;
      if (/^\d/.test(payload)) { TIER_GLOBAL = TIER_GLOBAL ? TIER_GLOBAL + "|" + payload : payload; return; }
      var colon = payload.indexOf(":");
      if (colon <= 0) return;
      TIER_SCOPES.push({ skuPrefix: payload.slice(0, colon).toUpperCase(), tiersStr: payload.slice(colon + 1) });
      return;
    }
  });
  function tiersForVariant(v) {
    var sku = String(v.sku || "").toUpperCase();
    var best = null, bestLen = 0;
    TIER_SCOPES.forEach(function (s) {
      if (sku.indexOf(s.skuPrefix) === 0 && s.skuPrefix.length > bestLen) { best = s; bestLen = s.skuPrefix.length; }
    });
    if (best) return parseTiers(best.tiersStr);
    if (TIER_SCOPES.length) return []; // scoped tags exist but none match
    return parseTiers(TIER_GLOBAL);
  }

  /* ---------- v3b percent ladder (arm B) ---------- */
  // Spec ({pct2, pct4}) for a variant from the bundle:v3b: tags — scoped or
  // unscoped, resolved by OSCV3B exactly like the migrate script / Function.
  function v3bSpec(v) {
    return V3 && v ? V3.resolveSpec(CFG.tags || [], v.sku || "") : null;
  }
  function v3bLadder(v) {
    var spec = v3bSpec(v);
    return spec && v ? V3.ladder(v.price, spec) : null;
  }
  // Greedy chunking — 1:1 with bundle-core.discountForGroup (checkout parity).
  function tierDiscountCents(units) { // units: [{price, tiers}]
    var us = units.slice().sort(function (a, b) { return b.price - a.price; });
    var opts = [];
    us.forEach(function (u) {
      u.tiers.forEach(function (t) { if (t.units > 1 && opts.indexOf(t.units) < 0) opts.push(t.units); });
    });
    opts.sort(function (a, b) { return b - a; });
    var discount = 0;
    while (us.length) {
      var applied = false;
      for (var oi = 0; oi < opts.length; oi++) {
        var n = opts[oi];
        if (n > us.length) continue;
        var chunk = us.slice(0, n);
        var bundleCents = 0;
        chunk.forEach(function (c) {
          c.tiers.forEach(function (t) { if (t.units === n && t.cents > bundleCents) bundleCents = t.cents; });
        });
        if (bundleCents <= 0) continue;
        var actual = chunk.reduce(function (s, c) { return s + c.price; }, 0);
        var d = Math.max(0, actual - bundleCents);
        if (d <= 0) continue;
        discount += d;
        us = us.slice(n);
        applied = true;
        break;
      }
      if (!applied) break;
    }
    return discount;
  }

  /* ---------- state ---------- */
  var cur = null;
  VARIANTS.forEach(function (v) { if (v.id === CFG.currentVariantId) cur = v; });
  if (!cur) cur = VARIANTS[0];
  var STATE = {
    size: cur ? cur.size : SIZES[0],
    color: cur ? cur.color : COLORS[0],
    tier: 1,
    slots: {}, // keyed by tier size (3 / 6 / 7): [{size,color}] once a multi tier is opened
    pillowPicks: null // [{size,color}] — free pillowcase set(s) on the big tier
  };

  // Campaign deep link: ?size=split-top-king (or ?size=stk / flextop-king)
  // preselects the size, so ads can land straight on the STK profile.
  try {
    var qSize = (new URLSearchParams(location.search).get("size") || "").toLowerCase().replace(/[^a-z]+/g, "");
    if (qSize) {
      var qAlias = { stk: "splittopking", flextopking: "splittopking", sk: "splitking" }[qSize] || qSize;
      SIZES.some(function (s) {
        if (String(s).toLowerCase().replace(/[^a-z]+/g, "") !== qAlias) return false;
        STATE.size = s;
        STATE.color = firstAvailableColor(s, STATE.color);
        return true;
      });
    }
  } catch (e) {}

  /* ---------- free pillowcase set (big tier) — user-pickable in BOTH arms ---------- */
  // One free set in each arm: arm B stamped at ATC and zeroed by the Function,
  // arm A stamped at ATC and zeroed by its discount code at checkout.
  var PILLOW_VARIANTS = (CFG.pillow && CFG.pillow.variants) || [];
  var PILLOW_SIZES = [];
  PILLOW_VARIANTS.forEach(function (p) { if (PILLOW_SIZES.indexOf(p.size) < 0) PILLOW_SIZES.push(p.size); });
  function pillowGiftCount() { return 1; }
  function pillowVariant(size, color) {
    for (var i = 0; i < PILLOW_VARIANTS.length; i++) {
      if (PILLOW_VARIANTS[i].size === size && PILLOW_VARIANTS[i].color === color) return PILLOW_VARIANTS[i];
    }
    return null;
  }
  function pillowColors(size) {
    var out = [];
    PILLOW_VARIANTS.forEach(function (p) { if (p.size === size && out.indexOf(p.color) < 0) out.push(p.color); });
    return out;
  }
  function ensurePillowPicks() {
    var count = pillowGiftCount();
    if (STATE.pillowPicks && STATE.pillowPicks.length === count) return STATE.pillowPicks;
    if (!PILLOW_VARIANTS.length) return (STATE.pillowPicks = []);
    var size = PILLOW_SIZES.indexOf("Queen") >= 0 ? "Queen" : PILLOW_SIZES[0];
    var picks = STATE.pillowPicks ? STATE.pillowPicks.slice(0, count) : [];
    // Default to colors matching the chosen sheet sets, when the pillowcase exists in them.
    var wanted = [];
    (curSlots() || []).forEach(function (s) { if (wanted.indexOf(s.color) < 0) wanted.push(s.color); });
    if (wanted.indexOf(STATE.color) < 0) wanted.push(STATE.color);
    wanted.forEach(function (c) { if (picks.length < count && pillowVariant(size, c)) picks.push({ size: size, color: c }); });
    while (picks.length < count) {
      var fallback = null;
      for (var i = 0; i < PILLOW_VARIANTS.length; i++) { if (PILLOW_VARIANTS[i].size === size) { fallback = PILLOW_VARIANTS[i]; break; } }
      fallback = fallback || PILLOW_VARIANTS[0];
      picks.push({ size: fallback.size, color: fallback.color });
    }
    return (STATE.pillowPicks = picks);
  }
  function pillowPicksValue() {
    var sum = 0;
    ensurePillowPicks().forEach(function (p) {
      var v = pillowVariant(p.size, p.color);
      sum += v ? v.price : (CFG.pillow.cents || 0);
    });
    return sum;
  }

  var elSizes = document.querySelector("[data-bb2-sizes]");
  var elColors = document.querySelector("[data-bb2-colors]");
  var elTiers = document.querySelector("[data-bb2-tiers]");
  var elMix = document.querySelector("[data-bb2-mix]");
  var elSlots = document.querySelector("[data-bb2-slots]");
  var elPillowSlots = document.querySelector("[data-bb2-pillowslots]");
  var elCta = document.querySelector("[data-bb2-cta]");

  function curVariant() { return findVariant(STATE.size, STATE.color); }
  function slotVariant(s) { return findVariant(s.size, s.color) || curVariant(); }
  function curSlots() { return STATE.tier > 1 ? (STATE.slots[STATE.tier] || []) : null; }
  // v3: arm B is the percent ladder — nothing is ever free. (The old BXGY
  // free-set path is retired; its cart stamping lives on dormant elsewhere.)
  function freeCount(n) { return 0; }

  // Rungs offered for the CURRENT variant: arm A keeps 1/3/6; arm B offers
  // 1/2/4, dropping any rung whose increment fails the $25 clamp — and
  // collapsing to singles-only when the variant has no v3b spec at all.
  function tierOptions() {
    if (ARM !== "B") return [1, 3, BIG_TIER];
    var l = v3bLadder(curVariant());
    var out = [1];
    if (l && l.ok2) out.push(2);
    if (l && l.ok4) out.push(4);
    return out;
  }

  /* ---------- pricing ---------- */
  // Returns { totalCents, wasCents (0 = hide), freeIdx: [slot indexes priced free] }
  function bundlePrice(slots) {
    var vs = slots.map(slotVariant);
    var sum = vs.reduce(function (s, v) { return s + (v ? v.price : 0); }, 0);
    var was = 0;
    vs.forEach(function (v) { was += v ? (v.cmp > v.price ? v.cmp : v.price) : 0; });
    if (ARM === "B") {
      // v3 percent ladder — group units by identical pct pair, discount within
      // each group (most expensive full price, next inc2, rest incN). 1:1 with
      // bundle-core.computeV3bDiscount so the preview matches checkout.
      var groups = {};
      vs.forEach(function (v) {
        if (!v) return;
        var spec = v3bSpec(v);
        if (!spec) return; // un-tagged variant: full price, never discounted
        var key = V3.specKey(spec);
        if (!groups[key]) groups[key] = { spec: spec, units: [] };
        groups[key].units.push(v.price);
      });
      var dB = 0;
      Object.keys(groups).forEach(function (k) {
        dB += V3.groupDiscountCents(groups[k].units, groups[k].spec);
      });
      var totalB = sum - dB;
      return { totalCents: totalB, wasCents: was > totalB ? was : 0, listCents: sum, freeIdx: [] };
    }
    var units = vs.map(function (v) { return { price: v ? v.price : 0, tiers: v ? tiersForVariant(v) : [] }; });
    var d = tierDiscountCents(units);
    var total = sum - d;
    return { totalCents: total, wasCents: was > total ? was : 0, freeIdx: [] };
  }
  function currentTotal() {
    var slots = curSlots();
    if (!slots) {
      var v = curVariant();
      return { totalCents: v ? v.price : 0, wasCents: v && v.cmp > v.price ? v.cmp : 0, freeIdx: [] };
    }
    return bundlePrice(slots);
  }

  function tierSub(n, totalCents) {
    if (n === 1) return money(totalCents) + " per set · everyday factory price";
    // Both arms: same "$X per set" sub, so the card layout is structurally
    // identical across the experiment (only the rungs/prices differ).
    return money(Math.round(totalCents / n)) + " per set";
  }
  // "What you get" bullets, old offer-box style: each free item + green value.
  function giftBullets(n, slots) {
    var out = [];
    function val(cents) {
      return ' <b>($' + Math.round(cents / 100).toLocaleString("en-US") + " value)</b>";
    }
    if (ARM === "B") {
      // v3: no free sets; the mask gift (@3+) is earned by the 4-pack, the
      // 6-set pillowcase gift is unreachable in this arm.
      if (n >= 3 && CFG.mask && CFG.mask.cents) out.push("FREE bamboo eye mask" + val(CFG.mask.cents));
    } else {
      if (n >= 6 && CFG.pillow && CFG.pillow.cents) {
        var pcA = STATE.tier === BIG_TIER && PILLOW_VARIANTS.length ? pillowPicksValue() : CFG.pillow.cents;
        out.push("FREE pillowcase set — you pick" + val(pcA));
      }
      if (n >= 3 && CFG.mask && CFG.mask.cents) out.push("FREE bamboo eye mask" + val(CFG.mask.cents));
    }
    return out;
  }
  function tierBadge(n) {
    if (ARM === "B") {
      // Percent claim front and center (½ PRICE when the tag says 50).
      var l = v3bLadder(curVariant());
      function pctTxt(p) { return p === 50 ? "\u00BD PRICE" : p + "% OFF"; }
      if (n === 2 && l) return { txt: "2ND SET " + pctTxt(l.pct2), dark: false };
      if (n === BIG_TIER) return { txt: "BEST VALUE" + (l ? " \u00B7 " + pctTxt(l.pct4) + " EXTRAS" : ""), dark: true };
      return null;
    }
    if (n === 3) return { txt: "FREE EYE MASK", dark: false };
    if (n === 6) return { txt: "BEST VALUE · FREE GIFTS", dark: true };
    return null;
  }

  /* ---------- renders ---------- */
  function renderSizes() {
    elSizes.innerHTML = "";
    SIZES.forEach(function (s) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "bb2-sizechip" + (s === STATE.size ? " is-selected" : "");
      b.innerHTML = esc(s) + "<small>" + money(sizeMinPrice(s)) + "</small>";
      b.addEventListener("click", function () {
        FB_HERO = false;
        STATE.size = s;
        STATE.color = firstAvailableColor(s, STATE.color);
        renderAll();
      });
      elSizes.appendChild(b);
    });
    var lbl = document.querySelector("[data-bb2-sizelabel]");
    if (lbl) lbl.textContent = STATE.size;
  }

  function colorDot(color, selected, size, onPick) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "bb2-dot bb2-sw-" + handleize(color) + (selected ? " is-selected" : "");
    var v = findVariant(size, color);
    if (!v || !v.available) b.disabled = true;
    b.title = b.disabled ? color + " — out of stock in " + size : color;
    b.setAttribute("aria-label", b.title);
    b.addEventListener("click", function () { if (!b.disabled) onPick(color); });
    return b;
  }
  function renderColors() {
    elColors.innerHTML = "";
    COLORS.forEach(function (c) {
      elColors.appendChild(colorDot(c, c === STATE.color, STATE.size, function (color) {
        FB_HERO = false;
        STATE.color = color;
        renderAll();
      }));
    });
    var lbl = document.querySelector("[data-bb2-colorlabel]");
    if (lbl) lbl.textContent = STATE.color;
    var showing = document.querySelector("[data-bb2-showing]");
    if (showing) showing.textContent = STATE.color;
    var v = curVariant();
    var main = document.querySelector("[data-bb2-main]");
    if (v && v.img && main && !FB_HERO) main.src = v.img;
  }

  function ensureSlots(n) {
    if (!STATE.slots[n]) {
      var arr = [];
      for (var i = 0; i < n; i++) arr.push({ size: STATE.size, color: STATE.color });
      STATE.slots[n] = arr;
    }
    return STATE.slots[n];
  }

  function renderTiers() {
    // The mix panel docks inside the tier list (under the selected card) —
    // park it outside before wiping so it survives the re-render.
    if (elMix && elMix.parentNode === elTiers) elTiers.parentNode.insertBefore(elMix, elTiers.nextSibling);
    elTiers.innerHTML = "";
    var opts = tierOptions();
    // Variant switch can retire the selected rung (clamp / missing v3b tag).
    if (opts.indexOf(STATE.tier) < 0) STATE.tier = 1;
    opts.forEach(function (n) {
      var price, was, slots = null;
      if (n === 1) {
        var v = curVariant();
        price = v ? v.price : 0;
        was = v && v.cmp > v.price ? v.cmp : 0;
      } else {
        slots = STATE.tier === n && STATE.slots[n] ? STATE.slots[n] : (function () {
          var arr = [];
          for (var i = 0; i < n; i++) arr.push({ size: STATE.size, color: STATE.color });
          return arr;
        })();
        var bp = bundlePrice(slots);
        price = bp.totalCents;
        was = bp.wasCents;
      }
      var title = n + " set" + (n > 1 ? "s" : "");
      var badge = tierBadge(n);
      var bullets = giftBullets(n, slots);
      var card = document.createElement("div");
      card.className = "bb2-tier" + (STATE.tier === n ? " is-selected" : "");
      card.setAttribute("role", "radio");
      card.setAttribute("aria-checked", STATE.tier === n ? "true" : "false");
      card.innerHTML =
        '<div class="bb2-tier-row"><span class="bb2-tier-radio" aria-hidden="true"></span><div style="min-width:0;flex:1 1 auto">' +
        '<div class="bb2-tier-label">' + title +
        (badge ? '<span class="bb2-tier-badge' + (badge.dark ? " bb2-tier-badge--dark" : "") + '">' + badge.txt + "</span>" : "") +
        "</div>" +
        '<div class="bb2-tier-sub">' + tierSub(n, price) + "</div></div>" +
        '<div class="bb2-tier-prices"><div class="bb2-tier-price">' + money(price) + "</div>" +
        (was ? '<div class="bb2-tier-was">' + money(was) + "</div>" : "") +
        "</div></div>" +
        (bullets.length
          ? '<ul class="bb2-tier-gifts">' + bullets.map(function (b) { return "<li>🎁 " + b + "</li>"; }).join("") + "</ul>"
          : "");
      card.addEventListener("click", function () {
        STATE.tier = n;
        if (n > 1) ensureSlots(n);
        renderAll();
      });
      elTiers.appendChild(card);
    });

    // (v3.1) The arm B upgrade line under the rungs was removed so both arms
    // render the same card structure — arm A has no element there either.
  }

  function renderMix() {
    var slots = curSlots();
    if (!slots) { elMix.hidden = true; return; }
    elMix.hidden = false;
    // Dock the panel right under the selected tier card.
    var selCard = elTiers.querySelector(".bb2-tier.is-selected");
    if (selCard) selCard.insertAdjacentElement("afterend", elMix);
    var cnt = document.querySelector("[data-bb2-mixcount]");
    if (cnt) cnt.textContent = String(STATE.tier);
    var bp = bundlePrice(slots);
    elSlots.innerHTML = "";
    slots.forEach(function (slot, i) {
      var row = document.createElement("div");
      row.className = "bb2-slot";
      var isFree = bp.freeIdx.indexOf(i) >= 0;
      var n = document.createElement("span");
      n.className = "bb2-slot-n" + (isFree ? " is-free" : "");
      n.textContent = isFree ? "SET " + (i + 1) + " 🎁" : "SET " + (i + 1);
      row.appendChild(n);

      var sel = document.createElement("select");
      SIZES.forEach(function (s) {
        var o = document.createElement("option");
        o.value = s;
        // Arm B: price the option as the variant this slot would actually get
        // (its color in size s), not the cheapest color of the size — the min
        // can undercut the real price and mislead. Arm A stays untouched.
        var optCents = sizeMinPrice(s);
        if (ARM === "B") {
          var ov = findVariant(s, firstAvailableColor(s, slot.color));
          if (ov) optCents = ov.price;
        }
        var priceTxt = money(optCents).replace(".00", "");
        o.textContent = isFree ? s + " · " + strike(priceTxt) + " FREE" : s + " · " + priceTxt;
        if (s === slot.size) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener("change", function () {
        slot.size = sel.value;
        slot.color = firstAvailableColor(slot.size, slot.color);
        renderAll();
      });
      row.appendChild(sel);

      // Color name lives on the top line next to the size select so it sits
      // in the same spot no matter how many swatches wrap below.
      var cname = document.createElement("span");
      cname.className = "bb2-slot-color";
      cname.innerHTML = "Color: <b>" + esc(slot.color) + "</b>";
      row.appendChild(cname);

      var note = document.createElement("span");
      note.className = "bb2-slot-note";
      var v = slotVariant(slot);
      if (isFree) note.innerHTML = "<s>" + money(v ? v.price : 0) + '</s> <span class="bb2-free">FREE</span>';
      else note.textContent = money(v ? v.price : 0);
      row.appendChild(note);

      // Swatches on their own line: only in-stock colors (sold-out ones are
      // hidden here, not struck).
      var dots = document.createElement("div");
      dots.className = "bb2-dots";
      COLORS.forEach(function (c) {
        var cv = findVariant(slot.size, c);
        if (!cv || !cv.available) return;
        dots.appendChild(colorDot(c, c === slot.color, slot.size, function (color) {
          slot.color = color;
          renderAll();
        }));
      });
      row.appendChild(dots);
      elSlots.appendChild(row);
    });

    renderGiftRows();

    var vs = slots.map(slotVariant);
    var singles = vs.reduce(function (s, v) { return s + (v ? v.price : 0); }, 0);
    var save = singles - bp.totalCents;
    var saveEl = document.querySelector("[data-bb2-mixsave]");
    if (saveEl) saveEl.textContent = save > 0 ? "You save " + money(save) + " vs single sets" : "";
    var totEl = document.querySelector("[data-bb2-mixtotal]");
    if (totEl) totEl.textContent = "Bundle total " + money(bp.totalCents);
  }

  // Free-gift rows in the mix panel: one user-pickable pillowcase set on the
  // big tier (both arms), and the navy eye mask (@3+).
  function renderGiftRows() {
    if (!elPillowSlots) return;
    elPillowSlots.innerHTML = "";
    if (STATE.tier < 3) return;
    if (STATE.tier >= 6) {
      if (PILLOW_VARIANTS.length) renderPillowPickers();
      else if (CFG.pillow && CFG.pillow.cents) {
        elPillowSlots.appendChild(staticGiftRow("CASES 🎁", "bb2-sw-default", "Pillowcase set · color-matched to your sets", CFG.pillow.cents));
      }
    }
    if (CFG.mask && CFG.mask.cents) {
      elPillowSlots.appendChild(staticGiftRow("MASK 🎁", "bb2-sw-navy", "Bamboo eye mask · Navy", CFG.mask.cents));
    }
  }
  function staticGiftRow(label, dotClass, text, cents) {
    var row = document.createElement("div");
    row.className = "bb2-slot bb2-slot--static";
    row.innerHTML =
      '<span class="bb2-slot-n is-free bb2-slot-n--gift">' + label + "</span>" +
      '<span class="bb2-dot ' + dotClass + '" aria-hidden="true"></span>' +
      '<span class="bb2-slot-static">' + text + "</span>" +
      '<span class="bb2-slot-note"><s>' + money(cents) + '</s> <span class="bb2-free">FREE</span></span>';
    return row;
  }
  function renderPillowPickers() {
    var picks = ensurePillowPicks();
    picks.forEach(function (pick, i) {
      var row = document.createElement("div");
      row.className = "bb2-slot";
      var n = document.createElement("span");
      n.className = "bb2-slot-n is-free bb2-slot-n--gift";
      n.textContent = (picks.length > 1 ? "CASES " + (i + 1) : "CASES") + " 🎁";
      row.appendChild(n);

      var sel = document.createElement("select");
      PILLOW_SIZES.forEach(function (s) {
        var o = document.createElement("option");
        o.value = s;
        var minP = 0;
        (PILLOW_VARIANTS || []).forEach(function (p) { if (p.size === s && (!minP || p.price < minP)) minP = p.price; });
        o.textContent = s + " pillowcases · " + strike(money(minP || CFG.pillow.cents || 0)) + " FREE";
        if (s === pick.size) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener("change", function () {
        pick.size = sel.value;
        if (!pillowVariant(pick.size, pick.color)) {
          var cs = pillowColors(pick.size);
          if (cs.length) pick.color = cs[0];
        }
        renderAll();
      });
      row.appendChild(sel);

      var cname = document.createElement("span");
      cname.className = "bb2-slot-color";
      cname.innerHTML = "Color: <b>" + esc(pick.color) + "</b>";
      row.appendChild(cname);

      var note = document.createElement("span");
      note.className = "bb2-slot-note";
      var pv = pillowVariant(pick.size, pick.color);
      note.innerHTML = "<s>" + money(pv ? pv.price : CFG.pillow.cents || 0) + '</s> <span class="bb2-free">FREE</span>';
      row.appendChild(note);

      var dots = document.createElement("div");
      dots.className = "bb2-dots";
      pillowColors(pick.size).forEach(function (c) {
        var cpv = pillowVariant(pick.size, c);
        if (!cpv || !cpv.available) return; // hide sold-out gift colors
        var b = document.createElement("button");
        b.type = "button";
        b.title = c;
        b.className = "bb2-dot bb2-sw-" + handleize(c) + (c === pick.color ? " is-selected" : "");
        b.addEventListener("click", function () { pick.color = c; renderAll(); });
        dots.appendChild(b);
      });
      row.appendChild(dots);
      elPillowSlots.appendChild(row);
    });
  }

  function renderPriceAndCta() {
    var v = curVariant();
    var one = document.querySelector("[data-bb2-price]");
    if (one && v) one.textContent = money(v.price);
    var was = document.querySelector("[data-bb2-was]");
    var pct = document.querySelector("[data-bb2-savepct]");
    if (was && pct && v) {
      if (v.cmp > v.price) {
        was.hidden = false;
        was.textContent = money(v.cmp);
        pct.hidden = false;
        pct.textContent = "SAVE " + Math.round(((v.cmp - v.price) / v.cmp) * 100) + "%";
      } else { was.hidden = true; pct.hidden = true; }
    }
    var anchorUs = document.querySelector("[data-bb2-anchor-us]");
    if (anchorUs && v) anchorUs.textContent = money(v.price);

    var t = currentTotal();
    var lbl = document.querySelector("[data-bb2-cta-label]");
    var prc = document.querySelector("[data-bb2-cta-price]");
    if (lbl) lbl.textContent = STATE.tier > 1 ? "Add bundle to cart" : "Add to cart";
    if (prc) prc.textContent = money(t.totalCents);
    // Crossed-out "was" on the button: compare-at total + the value of the free gifts.
    var ctaWas = document.querySelector("[data-bb2-cta-was]");
    if (ctaWas) {
      var giftsCents = 0;
      if (STATE.tier >= 3 && CFG.mask && CFG.mask.cents) giftsCents += CFG.mask.cents;
      if (STATE.tier >= 6 && CFG.pillow) {
        giftsCents += PILLOW_VARIANTS.length ? pillowPicksValue() : CFG.pillow.cents || 0;
      }
      var wasTotal = t.wasCents > 0 ? t.wasCents + giftsCents : 0;
      if (wasTotal > t.totalCents) {
        ctaWas.hidden = false;
        ctaWas.textContent = money(wasTotal);
      } else {
        ctaWas.hidden = true;
      }
    }
    if (elCta) elCta.disabled = STATE.tier === 1 && (!v || !v.available);
    var pay = document.querySelector("[data-bb2-payline]");
    if (pay) pay.textContent = "4 × " + money(Math.round(t.totalCents / 4)) + " SHOP PAY";

    var st = document.querySelector("[data-bb2-sticky-title]");
    var ss = document.querySelector("[data-bb2-sticky-sub]");
    if (st) st.textContent = STATE.tier > 1 ? STATE.tier + " sets · mix & match" : STATE.size + " · " + STATE.color + " · 1 set";
    if (ss) ss.textContent = t.wasCents ? money(t.totalCents) + " · was " + money(t.wasCents) : money(t.totalCents);
  }

  /* ---------- page-wide dynamic bits (comparison table, gift cards, FAQ) ---------- */
  function setDyn(key, txt) {
    document.querySelectorAll('[data-bb2-dyn="' + key + '"]').forEach(function (el) { el.textContent = txt; });
  }
  function priceLine(totalCents, sets) {
    return money(totalCents) + " · " + money(Math.round(totalCents / sets)) + "/set";
  }
  // Comparison "our price" cells + gift-card price lines follow the selected size.
  function updateDynamicPrices() {
    var v = curVariant();
    if (!v) return;
    var unit = v.price;
    var tiers = tiersForVariant(v);
    function tierTotal(n) {
      var best = 0;
      tiers.forEach(function (t) { if (t.units === n && t.cents > best) best = t.cents; });
      return best || unit * n;
    }
    var t3a = tierTotal(3), t6a = tierTotal(6);
    setDyn("sizelabel", STATE.size);
    setDyn("unit", money(unit));
    setDyn("t3a", priceLine(t3a, 3));
    setDyn("t6a", priceLine(t6a, 6));
    setDyn("per6a", money(Math.round(t6a / 6)));
    // STK comparison table: per-set price on the 3-pack.
    setDyn("per3a", money(Math.round(t3a / 3)));
    // Arm B (v3): "bundled per set" anchors on the 4-pack ladder total.
    if (ARM === "B") {
      var lB = v3bLadder(v);
      var t4b = lB && lB.ok4 ? lB.total4 : unit * 4;
      setDyn("t3b", priceLine(t4b, 4));
      setDyn("t6b", priceLine(t4b, 4));
      setDyn("per6b", money(Math.round(t4b / 4)));
      setDyn("per3b", money(Math.round(t4b / 4)));
    }
  }
  // Size profiles: Split Top King gets its own hero, comparison table, review
  // chips and FAQ block — dual-rendered in Liquid behind .bb2-stk-only /
  // .bb2-stk-hide, gated by html.bb2-stk (same pattern as the A/B arm classes).
  function updateSizeProfile() {
    var stk = String(STATE.size).toLowerCase() === "split top king";
    document.documentElement.classList.toggle("bb2-stk", stk);
  }
  // Split King ships two Twin XL fitted sheets — swap the box-contents copy in the FAQ.
  function updateBoxContents() {
    var splitKing = String(STATE.size).toLowerCase() === "split king";
    document.querySelectorAll(".bb2-a").forEach(function (el) {
      if (!el.dataset.bb2Orig) {
        if (el.textContent.indexOf("1 fitted sheet") < 0) return;
        el.dataset.bb2Orig = el.innerHTML;
      }
      el.innerHTML = splitKing
        ? el.dataset.bb2Orig.replace(/1 fitted sheet/g, "2 fitted sheets (Twin XL)")
        : el.dataset.bb2Orig;
    });
  }

  function renderAll() {
    renderSizes();
    renderColors();
    renderTiers();
    renderMix();
    renderPriceAndCta();
    updateDynamicPrices();
    updateBoxContents();
    updateSizeProfile();
  }

  /* ---------- add to cart ---------- */
  var adding = false;
  function addToCart() {
    if (adding) return;
    var items = [];
    var slots = curSlots();
    if (!slots) {
      var v = curVariant();
      if (!v || !v.available) return;
      items.push({ id: v.id, quantity: 1 });
    } else {
      var bp = bundlePrice(slots);
      slots.forEach(function (slot, i) {
        var sv = slotVariant(slot);
        if (!sv) return;
        var it = { id: sv.id, quantity: 1 };
        if (bp.freeIdx.indexOf(i) >= 0) {
          it.properties = { _osc_bxgy_free: "1", "Free set": "Buy more, get one free — while supplies last" };
        }
        items.push(it);
      });
      if (ARM === "B") {
        // Stamped gifts, exactly like the guided builder.
        if (STATE.tier >= 3 && CFG.mask && CFG.mask.available && CFG.mask.variantId) {
          items.push({ id: CFG.mask.variantId, quantity: 1, properties: { _osc_free_gift: "1", _osc_gift_min: "3", "Free gift": "With your bundle — while supplies last" } });
        }
        if (STATE.tier >= 6) {
          ensurePillowPicks().forEach(function (p) {
            var pv = pillowVariant(p.size, p.color);
            if (pv) items.push({ id: pv.id, quantity: 1, properties: { _osc_free_gift: "1", _osc_gift_min: String(BIG_TIER), "Free gift": "With your bundle — while supplies last" } });
          });
        }
      } else if (STATE.tier >= 6) {
        // Arm A: stamp the USER-PICKED pillowcase with the exact properties the
        // sidecart's auto-add would use, so its gift program sees the gift as
        // already present (no color-matched duplicate) and keeps it pinned to
        // qty 1 + zeroed by the discount code at checkout. The mask (@3) still
        // rides via the sidecart auto-add.
        ensurePillowPicks().forEach(function (p) {
          var pv = pillowVariant(p.size, p.color);
          if (pv) items.push({ id: pv.id, quantity: 1, properties: { _osc_free_gift: "1", "Free gift": "With your 6-pack — while supplies last" } });
        });
      }
    }
    if (!items.length) return;

    adding = true;
    elCta.classList.add("is-adding");
    var lbl = document.querySelector("[data-bb2-cta-label]");
    var prev = lbl ? lbl.textContent : "";
    if (lbl) lbl.textContent = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () {
        // A/B: bundles-per-day metric (both arms) — same event the builder fires.
        if (slots && window.StoreScaleAB) { try { window.StoreScaleAB.event("bxgy_bundle", "bundle"); } catch (e) {} }
      })
      .then(function () {
        adding = false;
        elCta.classList.remove("is-adding");
        if (lbl) lbl.textContent = prev;
        if (typeof window.getCartData === "function") window.getCartData();
        if (typeof window.toggleSideCart === "function") window.toggleSideCart();
        else if (typeof window.getCartData !== "function") window.location.href = "/cart";
      })
      .catch(function () {
        adding = false;
        elCta.classList.remove("is-adding");
        if (lbl) lbl.textContent = prev;
        alert("Sorry — something went wrong adding to your cart. Please try again.");
      });
  }
  if (elCta) elCta.addEventListener("click", addToCart);

  /* ---------- gallery thumbs ---------- */
  document.querySelectorAll("[data-bb2-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      FB_HERO = false;
      var main = document.querySelector("[data-bb2-main]");
      if (main && t.getAttribute("data-src")) main.src = t.getAttribute("data-src");
      document.querySelectorAll("[data-bb2-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
      t.classList.add("is-active");
    });
  });

  /* ---------- sticky bar ---------- */
  var sticky = document.querySelector("[data-bb2-sticky]");
  if (sticky && elCta && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      var below = entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle("is-visible", !entries[0].isIntersecting && below);
      sticky.setAttribute("aria-hidden", sticky.classList.contains("is-visible") ? "false" : "true");
    }, { threshold: 0 });
    io.observe(elCta);
    var sctA = document.querySelector("[data-bb2-sticky-cta]");
    if (sctA) sctA.addEventListener("click", addToCart);
  }

  /* ---------- deep links (?deal=N / ?bundle=N preselects a tier) ---------- */
  try {
    var dqs = new URLSearchParams(location.search);
    var deal = parseInt(dqs.get("deal") || dqs.get("bundle") || "0", 10);
    if (ARM === "B") {
      // v3 mapping: 1→1, 2→2, ≥3→4 — but only onto rungs this variant offers.
      deal = V3.mapPreselect(deal);
      if (deal > 1 && tierOptions().indexOf(deal) < 0) deal = 0;
      if (deal === 2 || deal === 4) { STATE.tier = deal; ensureSlots(deal); }
    } else if (deal === 3 || deal === BIG_TIER) {
      STATE.tier = deal;
      ensureSlots(deal);
    }
  } catch (e) {}

  /* ---------- live rating sync — same reviews.io numbers the bottom widget shows ---------- */
  function syncRating() {
    // Mirror the bottom widget's SKUCompilation exactly (base + size + WHIT),
    // so the numbers up here always equal the numbers it renders down there.
    var base = "";
    VARIANTS.some(function (v) {
      var at = String(v.sku || "").indexOf("__");
      if (at > 0) { base = String(v.sku).slice(0, at + 2).toUpperCase(); return true; }
      return false;
    });
    if (!base || typeof fetch !== "function") return;
    var skus = [];
    ["T", "TXL", "TXXL", "F", "Q", "OQ", "SQ", "STQ", "K", "SK", "STK", "TK", "CK", "SCK", "STCK", "WK"]
      .reverse()
      .forEach(function (s) { skus.push(base + s + "-WHIT"); });
    var store = "overstock-sheet-club";
    Promise.all([
      fetch("https://api.reviews.io/product/review?store=" + store + "&per_page=1&include_moderated=no&min_rating=3&sku=" + encodeURIComponent(skus.join(";"))).then(function (r) { return r.json(); }),
      fetch("https://api.reviews.io/merchant/reviews?store=" + store + "&per_page=1&min_rating=3").then(function (r) { return r.json(); }),
    ]).then(function (res) {
      var ps = res[0] && res[0].stats;
      var ms = res[1] && res[1].stats;
      var avg = ps && ps.average ? parseFloat(ps.average) : 0;
      // The widget's total = storewide merchant reviews + this product's reviews.
      var total = ((ms && parseInt(ms.total_reviews, 10)) || 0) + ((ps && parseInt(ps.count, 10)) || 0);
      if (avg > 0) {
        document.querySelectorAll("[data-bb2-rating-avg]").forEach(function (el) { el.textContent = avg.toFixed(1); });
      }
      if (total > 0) {
        document.querySelectorAll("[data-bb2-rating-count]").forEach(function (el) { el.textContent = total.toLocaleString("en-US"); });
      }
    }).catch(function () {});
  }
  syncRating();

  renderAll();

  if (FB_HERO) {
    // Swap to the lifestyle hero only once it actually loads — the asset can
    // be missing from the theme (404), which used to blank the hero for every
    // fbclid session. On failure, fall back to the selected variant's shot.
    var fbMain = document.querySelector("[data-bb2-main]");
    if (fbMain && CFG.fbImg) {
      var fbPre = new Image();
      fbPre.onload = function () { if (FB_HERO) fbMain.src = CFG.fbImg; };
      fbPre.onerror = function () {
        FB_HERO = false;
        var v = curVariant();
        if (v && v.img) fbMain.src = v.img;
      };
      fbPre.src = CFG.fbImg;
    }
  }
})();
